import { render, staticRenderFns } from "./newprogram.vue?vue&type=template&id=35c77b62&scoped=true"
import script from "./newprogram.vue?vue&type=script&lang=js"
export * from "./newprogram.vue?vue&type=script&lang=js"
import style0 from "./newprogram.vue?vue&type=style&index=0&id=35c77b62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c77b62",
  null
  
)

export default component.exports